import { useTranslation } from "../../hooks/useTranslation";
import { useMemo } from "react";
import { Tab as MuiTab } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { OrderTab } from "./components/OrderTab";
import { TabbedInterface } from "../../components/layout/tabbed-interface/TabbedInterface";

const tabList = [
  {
    labelKey: "all",
    filterValue: { field: "all", value: true },
  },
  {
    labelKey: "received",
    filterValue: { field: "status", value: "RECEIVED" },
  },
  {
    labelKey: "scheduledForShipment",
    filterValue: { field: "status", value: "SCHEDULED_FOR_SHIPMENT" },
  },
  {
    labelKey: "shipped",
    filterValue: { field: "status", value: "SHIPPED" },
  },
];

export const Orders = () => {
  const { translate } = useTranslation("pages.orders");

  const tabs = useMemo(
    () =>
      tabList.map((tab) => ({
        label: `tabs.${tab.labelKey}`,
        path: tab.labelKey,
        component: <OrderTab filterValue={tab.filterValue} />,
      })),
    []
  );

  return (
    <TabbedInterface
      tabs={tabs}
      defaultPath="active"
      translate={translate}
      editable={true}
      editableLocationKey={"pages.orders"}
      renderTab={(tab, count, index) => {
        const isDelayed = tab.path === "delayedPurchase" && !!count;
        if (!isDelayed) return null;

        return (
          <MuiTab
            key={tab.path}
            label={translate(tab.label) + ` (${count})`}
            value={index}
            sx={{
              textTransform: "none",
              color: "warning.main",
              fontWeight: "bold",
            }}
            icon={<Warning />}
            iconPosition="start"
          />
        );
      }}
    />
  );
};
